import { createRef } from 'react'
import currency from 'currency.js'
import moment from 'moment-timezone'

const TIME_ZONES_MX = ['America/Tijuana', 'America/Juarez', 'America/Hermosillo',  'America/Mazatlan', 'America/Cancun'];

/**
 * Is param a empty object ?.
 * @param {string} obj .
 * @returns {void} .
 */
const isEmptyObject = (obj) => Object.keys(obj).length === 0 && obj.constructor === Object

/**
 * DynamicRef Function
 * @param {String} total .
 * @return {void}
 */
const dynamicRef = (total) => {
  const refs = []
  for (let initial = 0; initial < total; initial++) {
    refs[initial] = createRef()
  }
  return refs
}

/**
 * Get Style Item By Property
 * @param {String} node .
 * @param {String} property .
 * @return {void}
 */
const getStyleItemByProperty = (node, property) => {
  const nodeStyle = window.getComputedStyle(node)
  const styles = parseInt(nodeStyle.getPropertyValue(property), 10)
  return styles
}

/**
 * Get Date by TimeZone
 * @param {String} date .
 * @param {String} country .
 * @param {String} appointmentTypeId - Id of the type appointment
 * @return {void}
 */
const getDateByCountryTimeZone = (date, country, appointmentTypeId = '') => {
  let time = moment(date).format('HH:mm')
  if (country === 'Colombia') {
    time = moment(date).tz('America/Bogota').format('hh:mm a').toUpperCase()
  } else if (country === 'Chile') {
    time = moment(date).tz('America/Santiago').format('hh:mm a').toUpperCase()
  } else if (country === 'Peru') {
    time = moment(date).tz('America/Lima').format('hh:mm a').toUpperCase()
  } else if (country === 'México') {
    let tz = moment.tz.guess()
    if (!TIME_ZONES_MX.includes(tz)) {
      tz = 'America/Mexico_City'
    }
    time = moment(date).tz(tz).format('hh:mm a').toUpperCase()
  }
  return time
}

/**
 * Get Discount
 * @param {String} countryCode .
 * @param {String} currencyProd .
 * @return {void}
 */
const getDiscount = (countryCode, currencyProd) => {
  let referralAmazon = `${currency(1000, { precision: 0 }).format()} ${currencyProd}`
  let referralDiscount = `${currency(1000, { precision: 0 }).format()} ${currencyProd}`
  switch (countryCode) {
  case 'co':
    referralAmazon = `${currency(169607, { precision: 0 }).format()} ${currencyProd}`
    referralDiscount = `${currency(169607, { precision: 0 }).format()} ${currencyProd}`
    break
  default:
    break
  }
  return { referralAmazon, referralDiscount }
}

/**
 * Choose Country Code
 * @param {String} country .
 * @returns {String} .
 */
const chooseCountryCode = (country) => {
  switch (country) {
  case 'Colombia':
    return 'co'
  case 'Peru':
    return 'pe'
  default:
    return 'mx'
  }
}

/**
 * Parse timetable
 * @param {String} timetable .
 * @returns {String} .
 */
const parseTimeTable = (timetable) => {
  let timeResult = ''
  let min = null
  let max = null
  try {
    if (timetable && timetable.saturday) {
      const saturday = timetable.saturday.map((element) => {
        let parts = element.split('-')
        parts = parts.map((part) => moment(part, 'HH:mm'))
        return parts
      })
      saturday.forEach(element => {
        element.forEach((part) => {
          if (!min) {
            min = part
          } else if (part.isBefore(min)) {
            min = part
          }
          if (!max) {
            max = part
          } else if (part.isAfter(max)) {
            max = part
          }
        })
      })
    }
    if (timetable && timetable.sunday) {
      const sunday = timetable.sunday.map((element) => {
        let parts = element.split('-')
        parts = parts.map((part) => moment(part, 'HH:mm'))
        return parts
      })
      sunday.forEach(element => {
        element.forEach((part) => {
          if (!min) {
            min = part
          } else if (part.isBefore(min)) {
            min = part
          }
          if (!max) {
            max = part
          } else if (part.isAfter(max)) {
            max = part
          }
        })
      })
    }
    if (timetable && timetable.weekdays) {
      const weekdays = timetable.weekdays.map((element) => {
        let parts = element.split('-')
        parts = parts.map((part) => moment(part, 'HH:mm'))
        return parts
      })
      weekdays.forEach(element => {
        element.forEach((part) => {
          if (!min) {
            min = part
          } else if (part.isBefore(min)) {
            min = part
          }
          if (!max) {
            max = part
          } else if (part.isAfter(max)) {
            max = part
          }
        })
      })
    }
    timeResult = `${min ? min.format('hh:mm a').toUpperCase() : ''} - ${max ? max.format('hh:mm a').toUpperCase() : ''}`
  } catch (err) {
    console.log(err)
  }
  return timeResult
}

/**
 * Get TimeZone by country
 * @param {String} country .
 * @return {string} timezone
 */
const getTimeZone = (country) => {
  let tz = ''
  if (country === 'Colombia') {
    tz = 'America/Bogota'
  } else if (country === 'Chile') {
    tz = 'America/Santiago'
  } else if (country === 'Peru') {
    tz = 'America/Lima'
  } else if (country === 'México') {
    tz = moment.tz.guess()
    if (!TIME_ZONES_MX.includes(tz)) {
      tz = 'America/Mexico_City'
    }
  }
  return tz
}

export default {
  parseTimeTable,
  chooseCountryCode,
  getDiscount,
  isEmptyObject,
  dynamicRef,
  getStyleItemByProperty,
  getDateByCountryTimeZone,
  getTimeZone
}
